<template>
    <div v-if="page">
        <v-row class="hero vw-100 overflow-hidden bg-dark text-white">
            <v-column class="hero-coach" ref="coach">
                <v-flex class="panel" direction="column" stretch>
                    <div>
                        <img
                            :src="page.coach.profile.profile_image.sizes.small"
                            @click="showProfilePhotoModal = true"
                            class="profile-pic mb-2"
                        />
                        <v-modal
                            :cancel="false"
                            :show.sync="showProfilePhotoModal"
                        >
                            <div class="text-center p-4">
                                <img
                                    :src="
                                        page.coach.profile.profile_image.sizes
                                            .small
                                    "
                                    @click="showProfilePhotoModal"
                                    class="w-100"
                                />
                            </div>
                        </v-modal>
                        <hr class="separator separator-dark" />
                        <h4 class="specialties">
                            <span
                                :class="`full-name d-inline-block text-white`"
                            >
                                <b>{{ page.coach.account.full_name }}</b>
                            </span>
                            <span class="d-inline-block">&nbsp;is&nbsp;</span>
                            <span
                                :key="i + word"
                                class="d-inline-block"
                                v-for="(word, i) in page.blurb.split(' ')"
                                >{{ word }}&nbsp;</span
                            >
                        </h4>
                        <div class="mt-4 social-links">
                            <v-button
                                :href="page.coach.profile.facebook_url"
                                circle
                                class="mr-2"
                                size="sm"
                                v-if="page.coach.profile.facebook_url"
                                variant="outline-light"
                            >
                                <fa-icon
                                    :icon="['fab', 'facebook-f']"
                                    fixed-width
                                />
                            </v-button>
                            <v-button
                                :href="page.coach.profile.instagram_url"
                                circle
                                class="mr-2"
                                size="sm"
                                v-if="page.coach.profile.instagram_url"
                                variant="outline-light"
                            >
                                <fa-icon
                                    :icon="['fab', 'instagram']"
                                    fixed-width
                                />
                            </v-button>
                            <v-button
                                :href="page.coach.profile.twitter_url"
                                circle
                                class="mr-2"
                                size="sm"
                                v-if="page.coach.profile.twitter_url"
                                variant="outline-light"
                            >
                                <fa-icon
                                    :icon="['fab', 'twitter']"
                                    fixed-width
                                />
                            </v-button>
                            <v-button
                                :href="page.coach.profile.youtube_url"
                                circle
                                size="sm"
                                v-if="page.coach.profile.youtube_url"
                                variant="outline-light"
                            >
                                <fa-icon
                                    :icon="['fab', 'youtube']"
                                    fixed-width
                                />
                            </v-button>
                        </div>
                    </div>
                    <v-flex
                        align="end"
                        class="flex-grow-1 d-md-none p-3"
                        justify="center"
                    >
                        <div
                            @click="scrollTo('cta')"
                            class="mobile-more text-muted"
                        >
                            Learn More
                            <h2 class="m-0 text-center mobile-more-arrow">
                                <fa-icon :icon="['far', 'angle-down']" />
                            </h2>
                        </div>
                    </v-flex>
                </v-flex>
            </v-column>
            <v-column
                class="bg-white text-dark hero-cta"
                cols="12"
                md="6"
                ref="cta"
            >
                <v-flex class="panel" direction="column" justify="start">
                    <div>
                        <h4>
                            Work with
                            {{ page.coach.account.full_name.split(" ")[0] }} on
                            <a
                                class="text-dark"
                                href="https://app.joinladder.com"
                                size="sm"
                                target="_blank"
                                >Ladder</a
                            >, <br class="d-none d-sm-inline-block" />the modern
                            coaching platform
                        </h4>
                        <hr class="separator" />
                        <ul
                            class="value-props list-unstyled"
                            style="font-size: 1.25rem;"
                        >
                            <li class="my-3">
                                <fa-icon
                                    :icon="['fad', 'comments']"
                                    class="mr-3"
                                    fixed-width
                                />Communicate anytime, anywhere
                            </li>
                            <li class="my-3">
                                <fa-icon
                                    :icon="['fad', 'tasks']"
                                    class="mr-3"
                                    fixed-width
                                />Personalized programming
                            </li>
                            <li class="my-3">
                                <fa-icon
                                    :icon="['fad', 'chart-line']"
                                    class="mr-3"
                                    fixed-width
                                />Progress tracking
                            </li>
                        </ul>
                        <v-button
                            @click="scrollTo('offers')"
                            class="mt-4 d-none d-md-inline"
                            size="lg"
                            v-if="offers"
                            variant="primary"
                            >{{ cta }}</v-button
                        >
                        <v-button
                            :to="{
                                name: 'CoachPageContact',
                                params: { ...$route.params }
                            }"
                            class="mt-4"
                            size="lg"
                            v-else
                            variant="primary"
                            >Get in touch</v-button
                        >
                    </div>
                </v-flex>
            </v-column>
        </v-row>
        <v-row
            class="bg-white text-dark mb-5 mb-md-0 justify-content-md-center offers"
            ref="offers"
            v-if="offers"
        >
            <v-column
                :key="offer.id"
                class="py-md-5 py-3"
                cols="12"
                md="4"
                v-for="(offer, i) in offers"
            >
                <v-flex class="border offer" direction="column">
                    <div class="m-4">
                        <h4>
                            <b>{{ offer.full_name || "#" + (i + 1) }}</b>
                        </h4>

                        <hr class="separator" />
                        <div>
                            <b v-if="parseFloat(offer.price)">
                                ${{ offer.price }}
                                <span class="text-muted">/mo</span>
                            </b>
                            <b v-else>FREE</b>
                        </div>
                    </div>
                    <h4
                        class="px-4 flex-grow-1"
                        style="font-size: 1.25rem; white-space: pre-line;"
                    >
                        {{ offer.description }}
                    </h4>
                    <div class="p-4 mt-4 border-top">
                        <v-button
                            @click="checkout(offer)"
                            block
                            size="lg"
                            variant="primary"
                            >{{ getOfferCTA(offer) }}</v-button
                        >
                    </div>
                </v-flex>
            </v-column>
        </v-row>
    </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";
import viewport from "@/utils/viewport.js";
import VModal from "@/components/ui/VModal";
import store from "@/store";

export default {
    name: "CoachPageView",
    components: {
        VModal
    },
    props: ["page"],
    data() {
        return {
            ctaAnimation: null,
            introAnimationComplete: false,
            showProfilePhotoModal: false
        };
    },
    computed: {
        cta() {
            // Modify the CTA based on the maximum number of trial days and if they have a offer
            if (this.offers && this.offers.length) {
                let maxDays = Math.max.apply(
                    Math,
                    this.offers.map(function(o) {
                        return o.trial_days;
                    })
                );
                if (maxDays) {
                    return `Try for ${maxDays} days`;
                } else {
                    return "See available offers";
                }
            } else {
                return "Get in touch";
            }
        },
        offers() {
            // See if there are any offers available
            let offers = this.page.offers;
            if (!offers || !offers.length) {
                return null;
            }

            // Sort by price
            offers.sort((a, b) => {
                return parseFloat(a.price) - parseFloat(b.price);
            });

            return offers;
        }
    },
    created() {
        window.addEventListener("scroll", this.scroll);

        this.$nextTick(() => {
            this.ctaAnimation = anime({
                targets: ".hero-cta",
                translateZ: [0],
                translateX: ["50vw", 0],
                opacity: [0, 1],
                duration: 1200,
                autoplay: false,
                easing: "easeOutExpo"
            });

            anime
                .timeline({ loop: false })
                .add({
                    targets: ".hero-coach .profile-pic, .hero-coach .separator",
                    opacity: [0, 1],
                    translateZ: [0],
                    duration: 600,
                    delay: 300,
                    easing: "easeInExpo"
                })
                .add(
                    {
                        targets: ".hero-coach .specialties span",
                        opacity: [0, 1],
                        translateZ: [0],
                        delay: anime.stagger(60),
                        easing: "easeInExpo",
                        complete: (() => {
                            this.ctaAnimation.play();
                        }).bind(this)
                    },
                    "-=600"
                )
                .add(
                    {
                        targets: ".social-links",
                        opacity: [0, 1],
                        translateZ: [0],
                        duration: 600,
                        delay: 300,
                        easing: "easeInExpo"
                    },
                    "-=600"
                )
                .add(
                    {
                        targets: ".hero-coach .mobile-more",
                        opacity: [0, 1],
                        translateZ: [0],
                        duration: 600,
                        easing: "easeInExpo",
                        complete: (() => {
                            this.introAnimationComplete = true;
                        }).bind(this)
                    },
                    "-=900"
                );

            anime({
                targets: ".mobile-more-arrow",
                translateZ: [0],
                direction: "alternate",
                loop: true,
                translateY: [5, 0],
                duration: 900,
                easing: "easeInOutQuad"
            });
        });
    },
    methods: {
        scroll() {
            if (this.introAnimationComplete) {
                let percent = 0.9 - 1.2 * (window.scrollY / viewport.height);
                // Only animate the panel on md or larger screens
                if (window.innerWidth > 900) {
                    this.ctaAnimation.seek(
                        this.ctaAnimation.duration * percent
                    );
                } else {
                    this.ctaAnimation.seek(this.ctaAnimation.duration);
                }
            }
        },
        scrollTo(ref) {
            window.scroll({
                top:
                    window.scrollY +
                    this.$refs[ref].$el.getBoundingClientRect().top,
                left: 0,
                behavior: "smooth"
            });
        },
        getOfferCTA(offer) {
            if (offer.trial_days) {
                return `Try for ${offer.trial_days} days`;
            } else {
                return "Sign up";
            }
        },
        checkout(offer) {
            // Track the product click in production
            if (window.analytics) {
                try {
                    window.analytics.track("Product Clicked", {
                        product_id: offer.id,
                        sku: offer.token,
                        category: "Coach Page Offer",
                        name: offer.full_name,
                        brand: offer.coach.account.full_name,
                        price: offer.price,
                        quantity: 1,
                        url: window.location.origin + this.$route.path
                    });
                } catch (e) {
                    // Silently fail tracking
                }
            }

            store.setOffer(offer);
            this.$router.push("checkout");
        }
    }
};
</script>

<style scoped lang="scss">
.offers {
    min-height: 90vh;
}
.offers .offer {
    min-height: 50vh;
}
.mobile-more {
    transition: color 300ms ease;
    cursor: pointer;
}
.mobile-more:hover {
    color: $white !important;
}
.specialties span {
    color: $gray;
}
.hero-cta {
    max-height: 100vh;
}
.specialties {
    font-size: 1.5rem;
    white-space: pre-wrap;
}
.panel {
    overflow: hidden;
    transition: all 300ms ease;
    padding-left: 8vw;
    padding-right: 8vw;
}
.hero .panel {
    min-height: 100vh;
    padding-top: 30vh;
}
.profile-pic {
    width: 4rem;
    height: 4rem;
}
.profile-pic:hover {
    transform: scale(1.05) !important;
}

.separator-dark {
    background-color: $gray !important;
}

@media (max-width: #{map-get($grid-breakpoints, "md")}) {
    .offers {
        min-height: auto;
    }
    .panel {
        min-height: auto !important;
        height: auto !important;
        max-height: auto !important;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
    .hero .panel {
        padding-top: 10%;
        min-height: var(--vh) !important;
        height: var(--vh) !important;
        max-height: var(--vh) !important;
    }
    .hero-cta .panel {
        height: auto !important;
        max-height: auto !important;
        min-height: auto !important;
        margin-bottom: 4rem;
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .panel.offers {
        height: auto !important;
        max-height: auto !important;
        min-height: auto !important;
        margin-bottom: 4rem;
    }
    .profile-pic {
        width: 6rem;
        height: 6rem;
    }
    .separator {
        width: 6rem !important;
    }
}
</style>
